import { FC } from 'react';
import './Sorting.scss';
import { DirectionChatType } from '@/shared/interfaces/inbox-filter.interface';

const items = [
  {
    key: 'asc',
    label: 'Most recent first',
  },
  {
    key: 'desc',
    label: 'The oldest first',
  },
];

type Props = {
  sortingApplied: DirectionChatType | string; // "asc" | "desc" | "";
  setSortingApplied: (
    value: DirectionChatType /* "asc" | "desc" | "" */,
  ) => void;
};

export const Sorting: FC<Props> = ({
  sortingApplied = '',
  setSortingApplied,
}) => {
  const handleChange = (value: DirectionChatType /* "asc" | "desc" | "" */) => {
    return () => setSortingApplied(value);
  };

  return (
    <div className="dropdown-list-container">
      {items.map((item) => (
        <div key={item.key}>
          <button
            data-testid="sort"
            className={`heading-button dropdown-button ${sortingApplied === item.key ? 'chosen' : ''}`}
            onClick={handleChange(item.key as DirectionChatType)}
          >
            {item.label}
          </button>
        </div>
      ))}
    </div>
  );
};
